<div class="historique-inventaire-container">
  <dx-data-grid
    #grid
    [dataSource]="historiques"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [columnAutoWidth]="true">

    <dxo-toolbar>
      <dxi-item name="groupPanel"></dxi-item>
      <dxi-item name="columnChooserButton"></dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <yo-button
            iconClass="fa fa-trash"
            [theme]="ButtonThemeEnum.DELETE"
            (onClick)="deleteSelected()">
          </yo-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100, 200]"
      [showNavigationButtons]="true"
      [showInfo]="true"
      infoText="{2} inventaire(s)">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>

    <dxi-column dataField="udpLibelle" caption="Unité de production"></dxi-column>
    <dxi-column dataField="inventaireDate" caption="Date inventaire" dataType="date" format="dd/MM/yyyy"></dxi-column>
    <dxi-column dataField="totalHT" caption="Total HT" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="totalTTC" caption="Total TTC" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="alimentaire" caption="Type" cellTemplate="typeCellTemplate">
      <dxo-lookup [dataSource]="alimentaireLookup" valueExpr="value" displayExpr="text"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="creePar" caption="Auteur"></dxi-column>
    <dxi-column dataField="dateCreation" caption="Date enregistrement" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>

    <div *dxTemplate="let cell of 'typeCellTemplate'">
      {{ getTypeAlimentaire(cell.value) }}
    </div>

  </dx-data-grid>
</div>

<dx-popup
  [showTitle]="true"
  title="Historiques non supprimés"
  [visible]="displayDeletePopupErrors"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeErrors()">
  <div class="error-container">
    <p>Ces historiques n'ont pas pu être supprimés car ils sont utilisés par une validation de fin de mois.</p>
    <dx-data-grid
      [dataSource]="errors"
      keyExpr="infosLine"
      [hoverStateEnabled]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [showRowLines]="true"
      [showBorders]="true">
      <dxi-column dataField="infosLine" caption="Historique non supprimé" [allowFiltering]="true"></dxi-column>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
    </dx-data-grid>
  </div>
</dx-popup>
